import { prop, DefaultOptions } from "../decorators/property";
import { backboneModelProperties } from "../decorators/backbone-properties";

const defaults = {
    Email: null,
    Password: null,
    IsAuthenticated: false,
    IsSuperUser: false,
    IsProductionUser: false,
    AuthenticatedByIp: false,
    AllowAdmin: false,
    IsIpRecognised: false,
    grant_type: "password",
    client_id: "justisoneweb",
    Indicators: [],
    FeatureFlags: []
};

@backboneModelProperties({
    defaults: defaults
})
export class AppUser extends Backbone.Model {
    @prop() public AuthenticatedByIp: boolean;
    @prop() public userName: string;
    @prop() public IsAuthenticated: boolean;
    @prop() public IsIpRecognised: boolean;
    @prop() public AllowAdmin: boolean;
    @prop() public IsProductionUser: boolean;
    @prop() public IsSuperUser: boolean;
    @prop() public Email: string;
    @prop() public OrganisationName: string;
    @prop() public FriendlyName: string;
    @prop() public UserId: number;
    @prop() public AuthenticationType: string;
    @prop() public Id: number;
    @prop() public RemainingTrialDays: number;
    @prop() public CustomHeader: string;
    @prop() public CustomFooter: string;
    @prop() public GoldVisionContactId: string;
    @prop() public GoldVisionAccountId: string;
    @prop() public IsTrialist: boolean;
    @prop() public Indicators: string[];
    @prop() public FeatureFlags: string[];
    @prop() public Idp: string;
    @prop(new DefaultOptions("free")) public Sku: string;

    constructor(options?) {
        super(options);
    }

    public canUserSaveSearchForm() {
        if (this.Sku.toLowerCase() === "free") {
            return false;
        }
        if (this.AuthenticatedByIp) {
            return false;
        }
        return true;
    }

    public hasFeatureFlag(flag: string): boolean {
        return this.FeatureFlags.indexOf(flag) !== -1;
    }

    public reset() {
        this.clear().set(defaults);
    }

    public get isAcademicUser() {
        return (this.AuthenticationType === "Athens" || this.AuthenticationType === "Institution");
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/authentication/app-user.ts